module.exports = __webpack_public_path__ + "static/media/bs.0f30e82c.svg";